import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 18,
	viewBox: "0 0 27 18",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25.75 15.9194L25.75 2.08062C25.75 1.24212 24.7801 0.775944 24.1253 1.29976L15.4761 8.21914C14.9757 8.61946 14.9757 9.38055 15.4761 9.78087L24.1253 16.7002C24.7801 17.2241 25.75 16.7579 25.75 15.9194Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.75 15.9194L11.75 2.08062C11.75 1.24212 10.7801 0.775944 10.1253 1.29976L1.47609 8.21914C0.975681 8.61946 0.97568 9.38055 1.47609 9.78087L10.1253 16.7002C10.7801 17.2241 11.75 16.7579 11.75 15.9194Z",
		fill: "currentColor"
	})]
});
export default SvgArrowDoubleLeft;
